enum WatermarkColor {
  LIGHT = 'light',
  DARK = 'dark',
}

export default WatermarkColor;
